document.addEventListener('DOMContentLoaded', function () {
  const gallery = document.querySelector('[id^="GalleryViewer-"]');
  const dotsContainer = document.querySelector('[id^="GalleryDots-"]');
  const dots = dotsContainer?.querySelectorAll('.slider-dot');
  const slides = gallery?.querySelectorAll('.slider__slide');
  const prevBtn = document.querySelector('#gallery-prev');
  const nextBtn = document.querySelector('#gallery-next');

  if (!gallery || !dots || !slides) return;

  let currentIndex = 0;

  // === Set Active Dot ===
  function updateDots(index) {
    dots.forEach(dot => dot.classList.remove('is-active'));
    dots[index]?.classList.add('is-active');
  }

  // === Go To Slide (with looping)
  function goToSlide(index) {
    if (index < 0) index = slides.length - 1;
    if (index >= slides.length) index = 0;

    currentIndex = index;
    slides[currentIndex].scrollIntoView({ behavior: 'smooth', inline: 'start' });
    updateDots(currentIndex);
  }

  // === Dots click
  dots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      goToSlide(index);
    });
  });

  // === Buttons
  prevBtn?.addEventListener('click', () => {
    goToSlide(currentIndex - 1);
  });

  nextBtn?.addEventListener('click', () => {
    goToSlide(currentIndex + 1);
  });

  // === Scroll Observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const index = Array.from(slides).indexOf(entry.target);
        if (index !== -1) {
          currentIndex = index;
          updateDots(index);
        }
      }
    });
  }, {
    root: gallery,
    threshold: 0.6,
  });

  slides.forEach(slide => observer.observe(slide));

  // === INIT check: Loop working or not
  function checkSliderLooping() {
    const firstSlide = slides[0];
    const lastSlide = slides[slides.length - 1];

    // Scroll to last slide
    lastSlide.scrollIntoView({ behavior: 'auto', inline: 'start' });

    // Wait then try scroll next to see if loops
    setTimeout(() => {
      const afterLast = gallery.scrollLeft;
      goToSlide(0); // return to start

      // After a bit, check if scroll resets
      setTimeout(() => {
        const afterReset = gallery.scrollLeft;

        if (afterLast === afterReset) {
          console.warn('⚠️ Slider loop NOT working natively. Manual loop fallback activated.');
        } else {
          console.info('✅ Native slider loop appears to be working.');
        }
      }, 500);
    }, 500);
  }

  // === Call on init
  checkSliderLooping();
});



if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        // Create variant-media mapping
        this.variantMediaMap = this.createVariantMediaMap();
        
        this.elements.viewer.addEventListener('slideChanged', this.debounce(this.onSlideChanged.bind(this), 500));

        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.querySelector('button')?.addEventListener(
            'click',
            this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false)
          );
        });

        if (this.dataset.desktopLayout?.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }

        this.activateFirstThumbnail();
        this.bindVariantChange();
      }

      createVariantMediaMap() {
        const map = {};
        // Get all variant-media associations from data attributes
        this.querySelectorAll('[data-variant-media]').forEach(el => {
          const variantId = parseInt(el.dataset.variantId);
          const mediaId = parseInt(el.dataset.mediaId);
          if (!map[variantId]) map[variantId] = [];
          map[variantId].push(mediaId);
        });
        return map;
      }

      debounce(fn, delay) {
        let timer = null;
        return function (...args) {
          clearTimeout(timer);
          timer = setTimeout(() => fn.apply(this, args), delay);
        };
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((el) => {
          el.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia &&
            activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail &&
              activeThumbnail.parentElement.firstChild !== activeThumbnail &&
              activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          
          if (this.elements.viewer.slider) {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }

          const rect = activeMedia.getBoundingClientRect();
          if (rect.top > -0.5) return;
          const scrollToTop = rect.top + window.scrollY;
          window.scrollTo({ top: scrollToTop, behavior: 'smooth' });
        });

        this.playActiveMedia(activeMedia);

        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveThumbnail(activeThumbnail);
          this.announceLiveRegion(activeMedia, activeThumbnail?.dataset.mediaPosition);
        }
      }

      updateMediaForVariant(variantId) {
        // Hide all media first
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach(media => {
          media.style.display = 'none';
          media.classList.remove('is-active');
        });
        
        // Hide all thumbnails
        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach(thumb => {
            thumb.style.display = 'none';
          });
        }

        // Show only media for this variant
        const mediaIds = this.variantMediaMap[variantId] || [];
        mediaIds.forEach(mediaId => {
          // Show in main viewer
          const media = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
          if (media) {
            media.style.display = 'block';
            if (!media.classList.contains('is-active')) {
              media.classList.add('is-active');
            }
          }
          
          // Show in thumbnails
          if (this.elements.thumbnails) {
            const thumb = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            if (thumb) thumb.style.display = 'block';
          }
        });

        // Activate first available media
        if (mediaIds.length > 0) {
          this.setActiveMedia(mediaIds[0], true);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails.querySelectorAll('button').forEach((el) => el.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);

        if (
          this.elements.thumbnails.isSlideVisible &&
          this.elements.thumbnails.isSlideVisible(thumbnail, 10)
        ) return;

        if (this.elements.thumbnails.slider) {
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src; // reload image
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }

      activateFirstThumbnail() {
        const firstThumbnail = this.elements.thumbnails.querySelector('[data-target]');
        if (firstThumbnail) {
          const mediaId = firstThumbnail.dataset.target;
          this.setActiveMedia(mediaId, false);
        }
      }

      bindVariantChange() {
        document.addEventListener('variant:change', (event) => {
          if (event.detail && event.detail.variant) {
            this.updateMediaForVariant(event.detail.variant.id);
          }
        });
      }
    }
  );
}